export default "@primary:  green;\n@secondary: blue;\n\n.section {\n  @color: primary;\n\n  .element {\n    color: @@color;\n  }\n}\n"